import { useTranslation } from 'react-i18next';
import React from 'react';

import WaitingModal from 'modals/WaitingModal';

import { WaitingModalContainerProps } from './types';

const WaitingModalContainer = ({ title, subtitle }: WaitingModalContainerProps = {}) => {
    const { t } = useTranslation();

    return (
        <WaitingModal
            captions={{ title: t(title ?? 'subscription.cancelDialog.loading'), subtitle: t(subtitle ?? '') }}
            dataLocator="subscriptionCancelationModalWaiting"
        />
    );
};

export default WaitingModalContainer;
